export function batchSizePayload(draft, selected) {
  const result = {};
  for (const id of selected) {
    const value = draft[id];
    if (value == null || value === '') continue;
    if (!/^\d+$/.test(String(value)) || !Number.isInteger(Number(value)) || Number(value) < 1 || Number(value) > 100)
      throw new Error('اندازهٔ بسته باید عدد صحیح بین ۱ تا ۱۰۰ باشد.');
    result[id] = Number(value);
  }
  return result;
}
export function savedBatchSizeDraft(sizes) {
  return Object.fromEntries(Object.entries(sizes || {}).map(([id,size]) => [id,String(size)]));
}
